import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-market",
  "use": "icon-market-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-market\"><path d=\"M981.333 981.333H42.667V42.667h563.2V128H128v768h768V392.533h85.333z\" /><path d=\"M196.267 460.8l51.2-51.2 256 256-51.2 51.2z\" /><path d=\"M921.6 179.2l51.2 51.2-503.467 503.467-51.2-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol